export const userPasswordRules = (role) => [
    {
        key: "minLength",
        message: trans('passwords.validation.min_length', {x: 8}),
        regex: /^.{8,}$/,
    },
    {
        key: "letters",
        message: trans('passwords.validation.letters'),
        regex: /[a-zA-Z]/,
    },
    // {
    //     key: "uppercase",
    //     message: trans('passwords.validation.uppercase'),
    //     regex: /[A-Z]/,
    // },
    {
        key: "number",
        message: trans('passwords.validation.number'),
        regex: /[0-9]/,
    },
    // {
    //     key: "specialCharacter",
    //     message: trans('passwords.validation.special_character'),
    //     regex: /[!@#$%^&*(),.?":{}|<>]/,
    // },
]
